import { debounce } from "throttle-debounce";
import g from "../globals/variables";

const Header = target => {
  const el = {
    header: target,
    headerCover: target.parentElement.querySelector(".header__cover"),
    navigation: target.querySelector(".navigation"),
    navigationDropdowns: target.querySelectorAll(".navigation__dropdown"),
    navigationMobileTrigger: target.querySelector(".navigation__mobile-trigger"),
    navigationTriggers: target.querySelectorAll(".navigation__trigger"),
    searchButton: target.querySelector("a.search__button"),
    searchDropdown: target.querySelector(".search"),
    searchForm: target.querySelector(".search__form"),
    searchInput: target.querySelector(".search__input input"),
    searchTriggerClose: target.querySelector(".search__button--close"),
    searchTriggerOpen: target.querySelector(".navigation__search"),
  };

  let currentActiveNavigation = null;
  let loaderTimeout = null;

  const method = {
    init: () => {
      el.navigationTriggers.forEach(trigger =>
        trigger.addEventListener("click", method.toggleNavigationDropdown),
      );
      el.navigationMobileTrigger.addEventListener("click", method.toggleMobileNavigation);

      if (el.searchTriggerClose)
        el.searchTriggerClose.addEventListener("click", method.hideSearchDropdown);
      if (el.searchTriggerOpen)
        el.searchTriggerOpen.addEventListener("click", method.showSearchDropdown);

      //* tweaking dropdowns depending on how many items are in each one +
      el.navigationDropdowns.forEach(dropdown => {
        if (dropdown.querySelectorAll("ul").length <= 5)
          dropdown.classList.add("navigation__dropdown--row");
      });

      //* disabling expandable subdropdowns for mobile
      el.navigationDropdowns.forEach(dropdown => {
        dropdown.querySelectorAll("ul").forEach(subDropdown => {
          if (subDropdown.querySelectorAll("li").length <= 1)
            subDropdown.setAttribute("data-empty", "true");
        });
      });

      //* toggling sub-dropdowns on mobile
      el.navigationDropdowns.forEach(dropdown => {
        dropdown.querySelectorAll("ul").forEach(subDropdown => {
          subDropdown.querySelector("li:first-of-type").addEventListener("click", event => {
            if (event.target.tagName === "H2" && !subDropdown.getAttribute("data-empty")) {
              if (subDropdown.getAttribute("data-expanded")) {
                subDropdown.removeAttribute("data-expanded");
                dropdown
                  .querySelectorAll("ul")
                  .forEach(item => item.removeAttribute("data-hidden"));
              } else {
                subDropdown.setAttribute("data-expanded", "true");
                dropdown.querySelectorAll("ul").forEach(item => {
                  if (!item.getAttribute("data-expanded")) {
                    item.setAttribute("data-hidden", "true");
                  }
                });
              }
            }
          });
        });
      });
    },

    hideNavigationDropdown: event => {
      if (event && event.type === "click") {
        let clickedElement = event.target;
        do {
          if (clickedElement === currentActiveNavigation) return;
          clickedElement = clickedElement.parentNode;
        } while (clickedElement);
      }

      currentActiveNavigation.classList.remove("navigation__item--active");
      el.headerCover?.classList.remove("header__cover--active");
      method.toggleOverlay();

      method.showAllDropdownsForMobile();
      window.removeEventListener("keyup", method.hideNavigationDropdownOnEscPress);
      window.removeEventListener("click", method.hideNavigationDropdown);
      currentActiveNavigation = null;
    },

    hideNavigationDropdownOnEscPress: event => {
      if (event.key.match("Escape")) method.hideNavigationDropdown();
    },

    toggleOverlay: () => {
      if (el.headerCover == null) return;
      if (
        document.body.style.position != "fixed" &&
        document.body.scrollHeight > window.innerHeight
      ) {
        const scrollPos = -window.scrollY + "px";
        document.body.style.position = "fixed";
        document.body.style.top = scrollPos;

        document.body.style.paddingRight = "10px";
        el.headerCover.style.pointerEvents = "unset";

        const headerElement = document.body.querySelector(".header");
        headerElement?.setAttribute("style", "padding-right: 10px");
      } else {
        document.body.style.position = "unset";

        window.scrollTo(0, -parseInt(document.body.style.top));
        document.body.style.paddingRight = "unset";
        el.headerCover.style.pointerEvents = "none";

        const headerElement = document.body.querySelector(".header");
        headerElement?.setAttribute("style", "padding-right: 0");
      }
    },

    toggleNavigationDropdown: event => {
      //* if already opened clicked
      if (currentActiveNavigation === event.target.parentElement) {
        method.hideNavigationDropdown();
        method.showAllDropdownsForMobile();
        return;
      }

      if (el.searchDropdown) method.hideSearchDropdown();
      if (currentActiveNavigation) method.hideNavigationDropdown();

      currentActiveNavigation = event.target.parentElement;
      currentActiveNavigation.classList.toggle("navigation__item--active");
      el.headerCover?.classList.toggle("header__cover--active");
      method.toggleOverlay();

      if (window.innerWidth < g.resolution.l) {
        method.hideAllDropdownsForMobile();
        currentActiveNavigation.classList.remove("navigation__item--hidden");
        el.headerCover?.classList.remove("header__cover--active");
        method.toggleOverlay();
      }

      if (currentActiveNavigation.classList.contains("navigation__item--active")) {
        window.addEventListener("keyup", method.hideNavigationDropdownOnEscPress);
        window.addEventListener("click", method.hideNavigationDropdown);
      } else {
        window.removeEventListener("keyup", method.hideNavigationDropdownOnEscPress);
        window.removeEventListener("click", method.hideNavigationDropdown);
      }
    },

    hideSearchDropdown: () => {
      el.searchDropdown.classList.remove("search--active");
      el.searchTriggerOpen.disabled = false;
      window.removeEventListener("keyup", method.hideSearchDropdownOnEscPress);
      window.removeEventListener("click", method.hideSearchDropdownOnOutsideClick);
    },

    hideSearchDropdownOnOutsideClick: event => {
      let clickedElement = event.target;

      do {
        if (clickedElement === el.searchDropdown || clickedElement === el.searchTriggerOpen) return;
        clickedElement = clickedElement.parentNode;
      } while (clickedElement);

      method.hideSearchDropdown();
    },

    hideSearchDropdownOnEscPress: event => {
      if (event.key.match("Escape")) method.hideSearchDropdown();
    },

    showSearchDropdown: () => {
      el.searchDropdown.classList.add("search--active");
      el.searchDropdown.classList.remove("search--performed");
      el.searchInput.value = "";
      el.searchInput.focus();
      el.searchTriggerOpen.disabled = true;
      window.addEventListener("keyup", method.hideSearchDropdownOnEscPress);
      window.addEventListener("click", method.hideSearchDropdownOnOutsideClick);
    },

    toggleMobileNavigation: () => {
      el.header.classList.toggle("header--mobile-navigation-active");
      method.toggleOverlay();
    },

    hideAllDropdownsForMobile: () => {
      el.navigationDropdowns.forEach(dropdown => {
        dropdown.parentElement.classList.add("navigation__item--hidden");
      });
    },

    showAllDropdownsForMobile: () => {
      el.navigationDropdowns.forEach(dropdown => {
        dropdown.parentElement.classList.remove("navigation__item--hidden");
      });
    },
  };

  method.init();
};

export default Header;
